import React, { useState } from 'react';
import styled from 'styled-components';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const BackgroundInner = styled.div`
    width: 100%;
    height: 100vh;
    overflow: hidden;
`;

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ImageContainer = styled.div`
    width: 200px; /* 크기 조정 */
    height: 200px; /* 크기 조정 */
`;
export const ProfileImage = styled.img`
    width: 200px; /* 크기 조정 */
    height: 200px; /* 크기 조정 */
`;
export const QuestionContainer = styled.div`
    width: 15px; /* 크기 조정 */
    height: 15px; /* 크기 조정 */
    margin-right: 4%;
`;
export const QuestionImage = styled.img`
    width: 15px; /* 크기 조정 */
    height: 15px; /* 크기 조정 */
`;

const TitleText = styled.div`
    font-weight: 600;
    font-size: xx-large;
    text-align: center;
    margin-top: 4%;
`;

const ContentText = styled.div`
    font-weight: 300;
    text-align: center;

    font-size: small;
`;
const InnerContainer = styled.div`
    border-radius: 20px;

    border: 1px solid #c1c1c1;
    position: relative;

    width: ${window.innerHeight / 2.4}px;
    height: ${window.innerHeight / 3.4}px;

    background-color: white;
    padding: 20px;
`;
const SkillContainer = styled.div`
    border-radius: 20px;

    border: 1px solid #c1c1c1;
    position: relative;

    width: ${window.innerHeight / 1}px;
    height: ${window.innerHeight / 1.59}px;
    background-color: white;
    margin-left: 1%;
    padding: 30px;
    display: flex;
`;
export const ContentIntoduce = styled.div`
    display: flex;
`;
export const SkillTitle = styled.div`
    color: #005eff;
    font-weight: 1000;
    font-size: 25px;
    margin-bottom: 15px;

    display: flex;
`;

export const EducationText = styled.div`
    font-weight: 650;
`;

export const EducationSubText = styled.div`
    margin-left: 7px;
    font-size: small;
`;

export const SkillText = styled.div`
    width: 35%;
    font-weight: 200;
    font-size: medium;
    text-align: center;
`;

export const CustomProgressBar = styled(ProgressBar)`
    background-color: white;
    color: #005cf9;
    border: 1px solid #005cf9;

    .progress-bar {
        background-color: #005cf9; /* 진행률 바 색상 */
    }
`;

export const SkillItem = ({ skill, now }) => {
    let skillText;
    if (Array.isArray(skill)) {
        skillText = skill.map((text, index) => (
            <React.Fragment key={index} style={{ textAlign: 'center' }}>
                {text}
                <br />
            </React.Fragment>
        ));
    } else {
        skillText = skill;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '25px' }}>
            <SkillText>{skillText}</SkillText>
            <CustomProgressBar style={{ width: '60%' }} animated now={now} />
        </div>
    );
};

function Introduce() {
    const [key, setKey] = useState('home');

    return (
        <BackgroundInner>
            <Container>
                <ImageContainer>
                    <ProfileImage alt="ProfileImage" src="images/profileImage.png" />
                </ImageContainer>
                <div style={{ textAlign: 'center' }}>
                    <TitleText>
                        <text style={{ color: '#FFA500' }}>커뮤니케이션 마에스트로:</text> <br />
                        함께 일하고 성장하는 팀원
                    </TitleText>
                    <br />

                    <ContentText>
                        React를 기반으로 한 웹/앱 프론트엔드 개발자로서, <br />
                        사용자 중심의 설계와 구현에 주력하며, 깊은 기술 이해와 다양한 프로젝트 경험을 바탕으로
                        <br />
                        직관적이고 매력적인 사용자 경험을 제공하는 것을 목표로 삼고 있습니다.
                        <br /> UI 구현 및 프로젝트 리더십 경험을 통해 효과적인 프로젝트 수행 능력을 갖추었으며, <br />
                        다부서 협업을 통해 함께 일하고 성장하는 팀원으로 소속되고 싶습니다.
                    </ContentText>
                </div>
            </Container>
            <Container style={{ marginTop: '2%' }}>
                <div>
                    <InnerContainer>
                        <SkillTitle>PROFILE</SkillTitle>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            <ContentIntoduce>
                                <QuestionContainer>
                                    <QuestionImage alt="question" src="images/id-cards.png" />
                                </QuestionContainer>
                                KIM JAE JUNG
                            </ContentIntoduce>

                            <ContentIntoduce>
                                <QuestionContainer>
                                    <QuestionImage alt="question" src="images/calendar.png" />
                                </QuestionContainer>
                                1997.10.23
                            </ContentIntoduce>

                            <ContentIntoduce>
                                <QuestionContainer>
                                    <QuestionImage alt="question" src="images/call.png" />
                                </QuestionContainer>
                                010 6305 0205
                            </ContentIntoduce>

                            <ContentIntoduce>
                                <QuestionContainer>
                                    <QuestionImage alt="question" src="images/letter.png" />
                                </QuestionContainer>
                                wowjd2524@gmail.com
                            </ContentIntoduce>
                            <ContentIntoduce>
                            <QuestionContainer>
                                    <QuestionImage alt="question" src="images/github.png" />
                                </QuestionContainer>
                                <a href="https://github.com/baebang" target="_blank" style={{ color: 'black' }}>
                                    GITHUB
                                </a>
                            </ContentIntoduce>
                        </div>
                    </InnerContainer>
                    <InnerContainer style={{ marginTop: '5%' }}>
                        <SkillTitle>EDUCATION</SkillTitle>
                        <EducationText>2024.11</EducationText>
                        <EducationText>
                            구름톤 우수상 수상
                            <a
                                href="https://drive.google.com/file/d/1GFMLExd1ie3RgMSH-sJcVUVj9ztD2pbN/view?usp=sharing"
                                target="_blank"
                            >
                                (수상)🔗
                            </a>
                        </EducationText>

                        <EducationText>2023.02 - 2023.08</EducationText>
                        <EducationText>
                            KAIST SW 아카데미 정글
                            <a
                                href="https://drive.google.com/file/d/1oxzb0sn4KPOBK4xuDhQ0eLSznSlCOmLs/view?usp=sharing"
                                target="_blank"
                            >
                                (수료)🔗
                            </a>
                        </EducationText>
                        <EducationSubText>: KAIST PintOS 프로젝트 참여</EducationSubText>
                        <EducationSubText>: Red-Black tree / malloc / 웹서버 C언어 프로젝트</EducationSubText>
                        <EducationText style={{ marginTop: '0%' }}>2019.02 - 2023.03</EducationText>
                        <EducationText>명지대학교 컴퓨터공학과 (졸업)</EducationText>
                    </InnerContainer>
                </div>

                <SkillContainer>
                    <div style={{ width: '50%', overflowY: 'scroll' }}>
                        <SkillTitle>CAREER</SkillTitle>

                        <EducationText>2024.06 - 2024.11</EducationText>
                        <EducationText>블라스트 SI 프로젝트 프론트엔드</EducationText>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - HACCP 식품 안전인증 어플리케이션 (2024.09 - 2024.11)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: 리액트네이티브 Expo를 사용해 공장 인증 어플리케이션 제작</EducationSubText>
                            <EducationSubText>
                                : 실시간데이터 입력 및 검증기능을 개발하여 업무처리속도와 정확도를향상.
                            </EducationSubText>
                        </div>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - 에너캠프 전기차 충천 어플리케이션 (2024.06 - 2024.09)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: AWS Amplify 기반의 웹 지도 서비스를 구축하여<br/> 지도 로딩 시간을 6분에서 1분으로 단축</EducationSubText>
                            <EducationSubText>
                                : 웹뷰브릿지 기술을 활용해 네이티브앱내에서 지도 데이터연동 및 상호작용 구현
                            </EducationSubText>
                        </div>

                        <EducationText style={{ marginTop: '4%' }}>2022.09 - 2022.12</EducationText>
                        <EducationText>영어 교육 플랫폼 튜터링 프론트엔드</EducationText>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - QA 프로세스 개선 자동화 (2022.10 - 2022.12)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: 테스트 자동화 프레임워크 도입 및 구축</EducationSubText>
                            <EducationSubText>
                                : Selenium, Cypress, Playwright 등 <br />
                                다양한 테스트 자동화 프레임워크 분석
                            </EducationSubText>
                        </div>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - 화상 서비스 퍼블리싱(2022.10 - 2022.12)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>
                                : 재사용 가능한 React 컴포넌트 설계 및 개발 (Button, Modal)
                            </EducationSubText>
                            <EducationSubText>: WCAG 접근성 가이드라인 준수</EducationSubText>
                            <EducationSubText>: Jira 등의 협업 도구 활용</EducationSubText>
                        </div>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - admin홈페이지 개편 (2022.09 - 2022.10)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: 관리자 페이지 텍스트 콘텐츠 최적화</EducationSubText>
                            <EducationSubText>: 관리자 페이지 푸터 영역에 접이식(folding) UI 구현</EducationSubText>
                        </div>

                        <EducationText style={{ marginTop: '4%' }}>2015.09 - 2019.01</EducationText>
                        <EducationText>넥슨 네트웍스 라이브실 QA (마비노기 영웅전)</EducationText>

                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - 대만 라이브 QA 담당 (2017.10 - 2019.01)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: 대만 서비스 업데이트 검수 및 배포지원</EducationSubText>
                            <EducationSubText>
                                : 문제 발생 시, 신속한 대응과 해결책 제시를 통해 안정적인 서비스 운영지원
                            </EducationSubText>
                        </div>
                        <EducationSubText style={{ fontWeight: '600', marginTop: '2%' }}>
                            - 한국 라이브 QA 담당 (2015.09 - 2017.10)
                        </EducationSubText>
                        <div style={{ paddingLeft: '4%' }}>
                            <EducationSubText>: 업데이트 검수 및 배포지원</EducationSubText>
                            <EducationSubText>: 동향 파악 및 밸런스 테스팅</EducationSubText>
                            <EducationSubText>: 라이브 서비스 운영 경험</EducationSubText>
                        </div>
                    </div>
                    <div style={{ width: '50%' }}>
                        <SkillTitle>
                            SKILL
                            <QuestionContainer style={{ marginLeft: '3%' }}>
                                <QuestionImage
                                    style={{ marginBottom: '30%' }}
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content="각 skill에 hover 하시면 자세한 상세 스킬활용 능력을 기제했습니다."
                                    alt="question"
                                    src="images/question-mark.png"
                                />
                            </QuestionContainer>
                        </SkillTitle>

                        <Tooltip id="my-tooltip" />
                        {/* <SkillTextContainer>
                            <ImageTilte src="images/PolygonTitle.png" />
                            <SkillText style={{ marginLeft: 15, color: '#005cf9' }}>FRONTEND</SkillText>
                        </SkillTextContainer> */}
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => {
                                setKey(k);
                            }}
                            className="mb-3"
                        >
                            <Tab eventKey="home" title="FRONTEND">
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>React Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>컴포넌트 기반 설계:</strong>
                                            <p>
                                                리액트의 핵심 개념 중 하나인 컴포넌트 기반 아키텍처를 활용하여 <br> 구조를 설계하고 재사용 가능한
                                                컴포넌트를 개발할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>상태 관리:</strong>
                                            <p>
                                                Zustand, Recoil 상태 관리 라이브러리를 경험해보았습니다.<br> 전역 상태를 효율적으로
                                                관리하고 데이터 흐름을 조율할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>라우팅 및 네비게이션:</strong>
                                            <p>
                                                리액트 라우터를 활용하여 다양한 페이지 간의 이동을 구현할 수 있습니다. <br>동적 라우팅과 네비게이션
                                                기능을 개발하는 데 능숙합니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>반응형 디자인:</strong>
                                            <p>
                                                Styled Components나 CSS 모듈 등의 스타일링 라이브러리를 사용하여 반응형 디자인을 구현할 수
                                                있습니다.<br> 미디어 쿼리를 활용하여 다양한 디바이스에 대응하는 UI를 개발할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>프로젝트 최적화:</strong>
                                            <p>
                                                성능 최적화와 코드 분할 등의 기술을 활용하여 프로젝트의 성능을 향상시키는 것에 관심이 있습니다.<br>
                                                사용자 경험을 개선하기 위해 노력합니다.
                                            </p>
                                        </li>
                                        <li>
                                        <strong>비동기 데이터 요청과 처리:</strong>
                                        <p>
                                        Axios를 사용하여 네트워크 요청을 보내고 응답을 처리하는 데 능숙합니다.<br>
                                       Axios의 인터셉터를 활용하여 요청과 응답에 대한 전역적인 설정을 구성하고, <br>
                                         요청 및 응답 데이터의 가공 및 에러 처리를 수행할 수 있습니다. 
                                        </p>
                                    </li>

                                         
                                    </ul>"
                                    data-tooltip-variant="warning"
                                >
                                    <SkillItem skill="React" now="90" />
                                </div>
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>React-Native Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>네비게이션과 라우팅:</strong>
                                            <p>
                                            네비게이션 라이브러리를 사용하여 애플리케이션 내에서의 다양한 화면 간의 이동 및 스택 관리를 구현할 수 있습니다. <br>
                                            스택 네비게이션, 탭 네비게이션, 드로어 네비게이션 등의 다양한 네비게이션 패턴을 구현하는 데 익숙합니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>비동기 처리:</strong>
                                            <p>
                                            네트워크 요청, 데이터 가져오기 및 처리와 같은 비동기 작업을 효율적으로 다룰 수 있습니다. <br>
                                            axios나 fetch API를 활용하여 데이터를 요청하고, <br>
                                            비동기 작업을 처리하는 Promise와 async/await 패턴을 익숙하게 사용합니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>커뮤니케이션 기능: </strong>
                                            <p>
                                            Firebase와 같은 라이브러리를 사용하여 알림, 소셜 미디어 연동 등과 같은 커뮤니케이션 기능을 구현할 수 있습니다.<br>
                                             실시간 데이터 동기화 및 이벤트 처리를 통해 사용자 경험을 향상시키는 것에 관심이 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>플랫폼 간 호환성:</strong>
                                            <p>리액트 네이티브를 사용하여 iOS와 Android 플랫폼 간에 코드를 공유하고<br>  플랫폼별로 최적화된 UI를 개발했던 경험이 있습니다.</p>
                                        </li>
                                    </ul>"
                                    data-tooltip-variant="warning"
                                >
                                    {' '}
                                    <SkillItem skill="React-Native" now="74" />
                                </div>
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>React-Query Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>React-Query를 통한 데이터 관리: </strong>
                                            <p>
                                            React-Query를 사용하여 애플리케이션의 데이터를 효율적으로 관리할 수 있습니다.<br>
                                            Query와 Mutation을 활용하여 데이터를 가져오고 변경하는 데 능숙하며, <br> 
                                            인터넷 연결 상태에 따라 자동으로 캐시를 관리하여 사용자 경험을 향상시킵니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>상태 관리 및 데이터 캐싱:</strong>
                                            <p>
                                            React-Query의 상태 관리 기능을 활용하여 데이터 로딩 상태를 추적하고, <br> 
                                            에러 처리와 리트라이 기능을 구현했던 경험이 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>Pagination 및 데이터 청크 처리:</strong>
                                            <p>
                                            무한 스크롤과 같은 인피니트 리스트를 구현했던 경험이 있습니다. <br>  
                                            이를 통해 대용량 데이터의 효율적인 로딩 및 표시를 가능케 하며, 사용자 경험을 향상시킬 수 있는 스킬을 가지고 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>반응형 디자인:</strong>
                                            <p>
                                                Styled Components나 CSS 모듈 등의 스타일링 라이브러리를 사용하여 반응형 디자인을 구현할 수
                                                있습니다.<br> 미디어 쿼리를 활용하여 다양한 디바이스에 대응하는 UI를 개발할 수 있습니다.
                                            </p>
                                        </li>
                                    
                                    </li>

                                         
                                    </ul>"
                                    data-tooltip-variant="warning"
                                >
                                    {' '}
                                    <SkillItem skill="React-Query" now="80" />
                                </div>
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>JS/TS(JavaScript/TypeScript) Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>모던 자바스크립트 활용:  </strong>
                                            <p>
                                            ES6+ 문법을 활용하여 모던 자바스크립트를 작성할 수 있습니다.<br> 
                                            화살표 함수, 템플릿 리터럴, 비구조화 할당, 클래스 등의 기능을 활용하여 <br> 
                                             코드를 더 간결하고 가독성 있게 작성할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>비동기 프로그래밍:</strong>
                                            <p>
                                            Promise와 async/await을 이용하여 비동기 작업을 처리할 수 있습니다. <br> 
                                            AJAX 요청이나 파일 로딩과 같은 비동기 작업을 효율적으로 관리하고,<br> 
                                             에러 처리 및 데이터 가공을 수행할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>라이브러리 및 프레임워크 활용: </strong>
                                            <p>
                                            jQuery, React, React-Native와 같은 라이브러리 및 프레임워크를 활용하여<br> 
                                            웹 애플리케이션을 개발할 수 있습니다.<br> 
                                             각 라이브러리의 문법과 기능을 숙지하고, 프로젝트에 적합한 라이브러리를 선택하여 사용합니다.</p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="JS / TS" now="80" />
                                </div>
                            </Tab>

                            <Tab eventKey="publishing" title="PUBLISHING">
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>HTML Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>웹 퍼블리싱 경험: </strong>
                                            <p>
                                            웹 퍼블리싱을 담당한 경험이 있습니다.  <br> 
                                            디자이너가 제공한 디자인 시안을 HTML과 CSS로 구현하여 웹 페이지를 제작하는 업무를 수행했습니다. <br> 
                                             이를 통해 웹 사이트의 시각적인 요소를 구현하고, 사용자가 의도한대로 웹 페이지가 표시되도록 보장했습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>시맨틱 마크업:</strong>
                                            <p>
                                            HTML5의 시맨틱 태그를 적극적으로 활용하여 웹 페이지의 구조를 의미론적으로 정의했습니다. <br> 
                                            태그를 사용하여 웹 페이지의 각 부분을 명확하게 구분할 수 있습니다.
                                            </p>

                                        </li>
                                        <li>
                                            <strong>폼 관리:  </strong>
                                            <p>
                                            다양한 폼 요소를 사용하여 사용자 입력을 받고 처리할 수 있습니다.<br> 
                                             폼 요소를 활용하여 사용자로부터 정보를 수집하고,<br> 
                                              label 태그를 사용하여 폼 요소와 레이블을 연결하여 접근성을 개선할 수 있습니다.</p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="HTML" now="75" />
                                </div>
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>SCSS/CSS Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>SCSS 활용:</strong>
                                            <p>
                                            SCSS(Sassy CSS)를 사용하여 CSS를 작성할 수 있습니다.<br> 
                                             변수, 중첩 규칙, mixin, extends 등의 기능을 활용하여 코드를 모듈화하고 재사용성을 높일 수 있습니다
                                            </p>
                                        </li>
                                        <li>
                                            <strong>CSS3 속성 활용:</strong>
                                            <p>
                                            CSS3의 다양한 속성을 활용하여 웹 요소의 스타일링을 꾸밀 수 있습니다. <br> 
                                            그림자 효과, 그라디언트, 변형(transform), 전환(transition), 애니메이션(animation) 등의 속성을 사용하여 <br> 
                                            웹 페이지에 다양한 효과를 적용할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>웹 애니메이션: </strong>
                                            <p>
                                            CSS3의 애니메이션 속성을 활용하여 웹 요소에 동적인 효과를 부여할 수 있습니다. <br> 
                                            키프레임을 정의하고, 애니메이션의 지속시간과 반복 등을 설정하여 다양한 애니메이션 효과를 구현할 수 있습니다.
                                            </p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="SCSS/CSS3" now="60" />
                                </div>
                            </Tab>
                            <Tab eventKey="backend" title="ETC">
                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>GIT Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>버전 관리:</strong>
                                            <p>
                                            Git을 사용하여 소스 코드의 버전을 관리하고 추적할 수 있습니다.<br> 
                                             커밋(commit), 브랜치(branch), 병합(merge) 등의 기능을 활용하여 <br> 
                                             프로젝트의 이력을 관리하고 변경 내용을 추적할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>원격 저장소 관리:</strong>
                                            <p>
                                            GitHub, GitLab, Bitbucket 등의 원격 저장소를 관리하고 활용할 수 있습니다.<br> 
                                             원격 저장소를 생성하고 관리하여 프로젝트를 백업하고, 다른 개발자들과 협업할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>협업:  </strong>
                                            <p>
                                            Git을 통해 여러 개발자가 함께 작업하는 프로젝트에서 효과적으로 협업할 수 있습니다.<br> 
                                             원격 저장소(remote repository)를 사용하여 코드를 공유하고, 풀 리퀘스트(pull request)를 통해 <br> 
                                             변경 사항을 검토하고 병합할 수 있습니다.
                                            </p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="Git" now="85" />
                                </div>

                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>Figma/Slack/Jira Skills</h5>
                                    <ul>
                                        <li>
                                            <strong>Figma: </strong>
                                            <p>
                                            Figma를 사용하여 디자인 작업을 수행할 수 있습니다. <br> 
                                            UI/UX 디자인을 위한 프로토타입 제작, 웹 및 앱 디자인, 컴포넌트 라이브러리 관리 등의 작업을 <br> 
                                            Figma를 통해 효과적으로 수행할 수 있습니다. <br> 
                                            또한, Figma를 통해 디자인 파일을 공유하고 협업하여 실시간으로 수정 및 피드백을 주고받을 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>Slack:</strong>
                                            <p>
                                             Slack을 사용하여 팀 간의 커뮤니케이션을 효율적으로 수행할 수 있습니다.<br> 
                                              채널을 생성하여 특정 주제에 대한 대화를 관리하고, DM을 통해 개별적으로 메시지를 주고받을 수 있습니다.<br> 
                                               또한, 파일 공유, 멘션, 이모지 리액션 등의 기능을 활용하여 팀원들과 소통을 원활하게 유지할 수 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                            <strong>Jira:  </strong>
                                            <p>
                                            Jira를 사용하여 프로젝트 관리 및 이슈 추적을 효과적으로 수행할 수 있습니다. <br> 
                                             프로젝트를 생성하고, 이슈를 등록하고 관리하며, 작업을 추적하여 프로젝트 진행 상황을 확인할 수 있습니다. <br> 
                                              또한, 스프린트 및 스토리 포인트 설정, 대시보드 및 보고서 작성 등의 기능을 활용하여 프로젝트를 효율적으로 관리할 수 있습니다.
                                            </p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="Figma/Slack/Jira" now="65" />
                                </div>

                                <div
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-variant="warning"
                                    data-tooltip-place="left"
                                    data-tooltip-html="<h5>Communication Skills</h5>
                                    <ul>
                                        <li>
                                          
                                            <p>
                                            웹/앱 프론트엔드 설계, 개발, 운영 경험을 토대로 다양한 프로젝트를 성공적으로 수행했습니다. <br> 
                                            사용자 경험을 중요시 여기며 풍부한 UI 구현 경험을 바탕으로 사용자 인터랙션에 대한 깊은 이해도를 보유하고 있습니다.
                                            </p>
                                        </li>
                                        <li>
                                           
                                            <p>
                                            기획 단계부터 참여하여 제한된 환경에서도 효과적인 프로젝트 리더십을 발휘했습니다.<br> 
                                             디자인, 마케팅, 운영 등 다양한 부서와의 긴밀한 협업 경험을 통해 팀 간의 원활한 소통과 협업을 이끌어냈습니다.
                                            </p>
                                        </li>
                                        <li>
                                         
                                            <p>
                                            비개발 직군에서의 근무 경험을 토대로 개발과 비개발 간 원활한 커뮤니케이션 능력을 갖추고 있습니다.<br> 
                                             상호 요구사항을 파악하고 기술적인 해결책을 제시하는 능력을 보유하고 있으며, <br> 
                                             프로젝트의 성공을 위해 다양한 직군 간의 협업을 선도했습니다.
                                            </p>
                                        </li>
                                       
                                    
                                    </li>

                                         
                                    </ul>"
                                >
                                    {' '}
                                    <SkillItem skill="Communication" now="100" />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </SkillContainer>
            </Container>
        </BackgroundInner>
    );
}

export default Introduce;
